// extracted by mini-css-extract-plugin
export var actionButton = "_78-1";
export var actionButtons = "_78-2";
export var actions = "_78-0";
export var aiUnread = "_78-10";
export var alignCenter = "_78-h";
export var backWrapper = "_78-3";
export var cellContainer = "_78-4";
export var checkboxContainer = "_78-5";
export var contentContainer = "_78-6";
export var contentHeader = "_78-8";
export var conversationsTableWrapper = "_78-s";
export var draftReplyBadgeContainer = "_78-m";
export var dropdownItem = "_78-b";
export var dropdownItemsContainer = "_78-a";
export var dropdownTitle = "_78-c";
export var errorIcon = "_78-7";
export var filter = "_78-d";
export var gray = "_78-i";
export var headerActionButtons = "_78-e";
export var headerCheckboxContainer = "_78-f";
export var icon = "_78-j";
export var menuContainer = "_78-k";
export var noMoreTicketsIcon = "_78-12";
export var noMoreTicketsSubText = "_78-13";
export var oneLine = "_78-l";
export var optionsButton = "_78-n";
export var plus = "_78-o";
export var portalButtonsWrapper = "_78-g";
export var red = "_78-p";
export var scrolledTop = "_78-9";
export var search = "_78-q";
export var selectedConversationsCount = "_78-r";
export var spinner = "_78-t";
export var strong = "_78-u";
export var summaryCell = "_78-v";
export var tableContainer = "_78-11";
export var tagContainer = "_78-w";
export var threeDots = "_78-x";
export var twoLines = "_78-y";
export var unread = "_78-z";